import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

export interface LocationMergePair {
    primaryid: number; primaryname: string; primaryreference?: string;
    duplicateid: number; duplicatename: string; duplicatereference?: string; score: number;
}
export interface LocationMergeReference {
    table: string; column: string; primaryCount: number; duplicateCount: number; supported: boolean;
}
export interface LocationMergePreview {
    primary: Record<string, any>; duplicate: Record<string, any>; fields: string[];
    contacts: Record<string, any>[]; merchandisers: Record<string, any>[];
    aliases: Record<string, any>[];
    references: LocationMergeReference[]; fingerprint: string; mergeable: boolean; blockers: string[];
}
export interface LocationMergeRequest {
    primaryId: number; duplicateId: number; fingerprint: string; fieldSources: Record<string, number>;
    contactIds: number[]; merchandiserIds: number[];
}

@Injectable({ providedIn: 'root' })
export class LocationMergeService {
    private http = inject(HttpClient);
    private url = `${environment.restApiUrl}location-merges`;

    candidates(company: number, search: string, page: number) {
        return this.http.get<LocationMergePair[]>(`${this.url}/candidates`, { params: this.params(company).set('search', search).set('page', page) });
    }
    search(company: number, search: string) {
        return this.http.get<{ id: number; name: string; reference?: string; address?: string }[]>(`${this.url}/search`,
            { params: this.params(company).set('search', search) });
    }
    preview(company: number, primaryId: number, duplicateId: number) {
        return this.http.post<LocationMergePreview>(`${this.url}/preview`, { primaryId, duplicateId }, { params: this.params(company) });
    }
    merge(company: number, request: LocationMergeRequest) {
        return this.http.post<{ locationId: number }>(this.url, request, { params: this.params(company) });
    }
    resolve(company: number, locationId: number) {
        return this.http.get<{ locationId: number }>(`${this.url}/resolve`, { params: this.params(company).set('locationId', locationId) });
    }
    private params(company: number) { return new HttpParams().set('owningCompanyId', company); }
}
